/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import { Icon } from '@els/els-react--icon';

function ConfirmationPopup(props) {
  const {
    title,
    text,
    submitButtonText,
    dismissButtonText,
    isCancelButton,
    registerText,
    onClose,
    onConfirm,
    onRegister,
    closed,
    selfClose,
  } = props;
  useEffect(
    () => () => {
      onClose();
    },
    []
  );
  return (
    <>
      <div className="react-dialogs-backdrop" />
      <GeneralDialogLayout
        className="history-confirmation-popup"
        resizable={false}
        movable={false}
        closeBtn={false}
        selfClose={selfClose}
        backdrop={false}
        closed={closed}>
        <div role="dialog" aria-labelledby="history-confirm-dialog-title">
          <header>
            <h4 id="history-confirm-dialog-title" className="u-els-padding-1x">
              <Icon sprite="InformationSolidSquare" size="m" className="u-els-color-info u-els-padding-right-1o4" isVisible isDecorative />
              {title}
            </h4>
          </header>
          <section className="u-els-padding-left-1x u-els-padding-bottom-1x u-els-padding-right-1x">{text}</section>
          <footer className="u-els-padding-1x">
            <span className="button-container">
              {isCancelButton && (
                <ButtonWithIcon
                  type="secondary"
                  sprite="Close"
                  size="small"
                  iconRight
                  className="e2e-confirmation-modal-cancel"
                  name="cancel"
                  onClick={onClose}>
                  {dismissButtonText}
                </ButtonWithIcon>
              )}
              <ButtonWithIcon
                type="primary"
                sprite="ChevronRight"
                size="small"
                iconRight
                className="e2e-confirmation-modal-submit"
                name="confirm"
                onClick={onConfirm}>
                {submitButtonText}
              </ButtonWithIcon>
              {registerText && (
                <ButtonWithIcon
                  type="primary"s
                  sprite="ChevronRight"
                  size="small"
                  iconRight
                  className="e2e-confirmation-modal-register"
                  name="register"
                  onClick={onRegister}>
                  {registerText}
                </ButtonWithIcon>
              )}
            </span>
          </footer>
        </div>
      </GeneralDialogLayout>
    </>
  );
}

ConfirmationPopup.defaultProps = {
  onConfirm: () => {},
  onClose: () => {},
  onRegister: () => {},
  submitButtonText: 'Yes',
  dismissButtonText: 'Cancel',
  isCancelButton: true,
};

ConfirmationPopup.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  dismissButtonText: PropTypes.string,
  registerText: PropTypes.string,
  isCancelButton: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  onRegister: PropTypes.func,
  selfClose: PropTypes.func,
  closed: PropTypes.bool,
};

export default withRouter(ConfirmationPopup);
